export default () => {
    return [
        {
            path: '/config',
            name: 'config',
            component: () => import('./views/config.vue'),
        },
    ];
};
